import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './index.css'
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useCategory } from "../../hooks/useCategory";
import 'animate.css'
import LazyImage from "../LazyImage/LazyImage";
import styles from './index.module.css'


type CategoryItemProps = {
    category: any;
    legendColor: string;
    noShadow?: boolean;
    showName?: boolean;
}

type CatalogType = {
    id: number;
    catalog: string;
    imgCatalog: string;
}

type CatalogItemProps = {
    catalog: any;
    legendColor: string;
    showName: boolean;
    isBlock?: boolean;
    useShadow?: boolean;
}

export function CatalogItem({ catalog, legendColor, showName }: CatalogItemProps) {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const [loadingImage, setLoadingImage] = useState(true);
    const categories = [catalog];
    return (
        <Carousel
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
        >
            {categories.map(() =>
                <div className="item" key={catalog.id} onClick={() => navigate(`/${pluginspace_id}/catalog/${window.btoa(catalog.id.toString())}`)}>
                    <div className="overlay"></div>
                    <img style={loadingImage ? { visibility: 'hidden' } : {}} src={catalog.imgCatalog} className="img-carousel" onLoad={() => setLoadingImage(false)} />
                    {showName && <p className="legend-category" style={{ color: legendColor }}>{catalog.catalog}</p>}
                </div>)
            }
        </Carousel>
    );
}


export function CatalogListItem({ catalog, showName, isBlock, useShadow }: CatalogItemProps) {

    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const [loadingImage, setLoadingImage] = useState(true);

    console.log("CatalogListItem", catalog);


    return (
        <div className={`${!isBlock ? `  ${styles.grid_1_col}  ` : `  ${styles.grid_2_col}  `}`}>
            {catalog.map((item: any) =>
                <div className={styles.container}
                    style={{
                        position: 'relative',
                    }} key={item.id} onClick={() => navigate(`/${pluginspace_id}/catalog/${window.btoa(item.id.toString())}`)}>
                    {useShadow && <div className={styles.overlay}></div>}
                    <img style={loadingImage ? { visibility: 'hidden' } : {}} src={item.imagem} className="img-carousel" onLoad={() => setLoadingImage(false)} />
                    {showName && <p className={styles.nome_catalog}  >{item.nome}</p>}
                </div>

            )
            }
        </div>


    );
}




export function CategoryItemAtacado({ category, showName, noShadow }: CategoryItemProps & { animationDelay: number }) {
    const navigate = useNavigate();
    const { pluginspace_id } = useParams();
    const { getAppConfig } = useAppConfig();
    const { getCategoriesAll, getChildrenCategories } = useCategory();



    const goTo = async (id: number) => {
        const config = await getAppConfig()

        const categories = await getChildrenCategories(category.id.toString())

        const categoriesChild = categories.filter((item: any) => item.id !== category.id)
        localStorage.removeItem("pageHistory");



        if ((config && config.content && config.content.pdv && config.content.pdv.agroupCategory) || categoriesChild.length === 0) {
            navigate(`/${pluginspace_id}/pdv/${category.id}`)

        } else {
            navigate(`/${pluginspace_id}/subcategory/${category.id}`)
        }

    };

    return (
        <div
            className={`${styles.container} animate__animated animate__fadeInUp`}
            // Aplica o delay
            onClick={async () => await goTo(category.id)}>
          {noShadow && <div className={styles.overlay}></div>}
            <LazyImage
                src={category.imagem}
                alt={category.name}
                className={styles.container_image}
            />
            {showName && <span className={styles.nome_catalog}>{category.nome}</span>}
        </div>
    );
}